import Style from './successfull.module.scss'
import Logo from '../../../../assets/theme6/quizwall.png'
import SuccesssAnimation from '../Animation/successAnimation'
import SuccessImg from '../../../../assets/theme6/failed.svg'
import { useNavigate } from 'react-router-dom'
import HappySuccess from '../component/HappySuccess'
import PerfectButtonIconLeft from '../../../../assets/svg/PerfectButtonIconLeft'
import PerfectButtonIconRight from '../../../../assets/svg/PerfectButtonIconRight'

const Successfull = () => {
const navigation = useNavigate()
  return (
    <>
      <div className={Style.container}>
        <div className={Style.logo}>
          <img src={Logo} width={"130px"} alt="logo" />
        </div>
        <div style={{ position: "absolute", top: "50px" }}>
          <SuccesssAnimation />
        </div>
        
        <div className={Style.reward}>
          <HappySuccess h3Text={`Hurrah!`} h5Text={`Gift Card Successfully\n purchased`} />
        </div>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "100px",flexDirection: "column" }}>
          <button className={Style.btn} onClick={()=>navigation("/myVouchers")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
              <path d="M14 5.83832L5.17647 1.60303M12.2353 10.7795L2 10.7795M14 15.3677L8 18.8971" stroke="white" stroke-width="2.11765" stroke-linecap="round" />
            </svg>
            <p>My gift cards</p>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
              <path d="M2 5.83832L10.8235 1.60303M3.76471 10.7795L14 10.7795M2 15.3677L8 18.8971" stroke="white" stroke-width="2.11765" stroke-linecap="round" />
            </svg>
          </button>
          <div className={Style.home_button} onClick={()=>navigation("/home-challenge")}><PerfectButtonIconRight fillColor={"#FA5743"}/> <p className={Style.home_button_text}>Home</p><PerfectButtonIconLeft fillColor={"#FA5743"}/> </div>
        </div>
      </div>
    </>
  )
}

export default Successfull